var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductSpecialNode',{attrs:{"web-node-name":"actie","title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }